import React from 'react'
import styled from 'styled-components'
import moment from 'moment'

const Content = styled.footer`
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #0f0f0f;
  font-size: 14px !important;
  padding: 4px 0;
  color: #919191 !important;
  text-align: center;
`

function Footer() {
  return (
    <Content>
        <span>© {moment().format('YYYY')} NHJ do Brasil | Todos os direitos reservados</span>
    </Content>
  )
}

export default Footer
